import { createStyles } from '@/hooks';
import { colors, guardianColors, withOpacity } from '@/theme/colors';

export const useStyles = createStyles(({ scale }) => ({
  scrollContent: {
    paddingHorizontal: scale(20),
  },
  scrollContentTablet: {
    paddingTop: scale(20),
  },
  tabletContent: {
    width: '75%',
    alignSelf: 'center',
  },
  pressed: {
    opacity: 0.72,
  },
  summaryCard: {
    backgroundColor: colors['0'],
    borderRadius: scale(8),
    padding: scale(12),
    shadowColor: '#D5D9E2',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.3,
    shadowRadius: 3,
    elevation: 1,
  },
  summaryTitle: {
    color: guardianColors['10'],
    flexShrink: 1,
  },
  mutedText: {
    color: guardianColors['6'],
  },
  progressTrack: {
    height: scale(6),
    borderRadius: scale(8),
    backgroundColor: guardianColors['3'],
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: scale(10),
    backgroundColor: guardianColors['Main/Main'],
  },
  sectionTitle: {
    color: guardianColors['10'],
    paddingTop: scale(16),
    paddingBottom: scale(12),
  },
  sectionRow: {
    paddingTop: scale(22),
    paddingBottom: scale(16),
  },
  sectionTitleTablet: {
    color: guardianColors['10'],
    flexShrink: 1,
  },
  levelList: {
    flex: 1,
  },
  levelGridContent: {
    rowGap: scale({ phone: 8, tablet: 16 }),
  },
  levelGridColumn: {
    columnGap: scale(16),
  },
  levelGridItem: {
    flex: 1,
  },
  levelCardPressable: {
    width: '100%',
  },
  levelCard: {
    borderRadius: scale(12),
    overflow: 'hidden',
    position: 'relative',
  },
  levelCardContent: {
    width: '100%',
    borderRadius: scale(12),
    backgroundColor: withOpacity(colors['0'], 0.9),
    overflow: 'hidden',
    paddingHorizontal: scale(12),
    paddingVertical: scale(10),
  },
  lockedLevelCard: {
    backgroundColor: withOpacity(colors['0'], 0.3),
  },
  levelSeal: {
    width: scale(50),
    height: scale(50),
  },
  badgeCountText: {
    color: guardianColors['10'],
  },
  lockedBadgeCountText: {
    color: guardianColors['5'],
  },
  levelStatus: {
    flexShrink: 0,
  },
  unlockText: {
    color: guardianColors['5'],
  },
  progressDot: {
    width: scale(8),
    height: scale(8),
    borderRadius: scale(8),
  },
  progressDotCurrentOuter: {
    width: scale(12),
    height: scale(12),
    borderRadius: scale(12),
  },
  progressDotCurrentInner: {
    width: scale(8),
    height: scale(8),
    borderRadius: scale(8),
    borderWidth: scale(1),
  },
  historyButton: {
    alignSelf: 'flex-end',
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(10),
    paddingTop: scale(8),
  },
  historyText: {
    color: guardianColors['Main/Main'],
  },
  historyButtonTablet: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: scale(12),
    flexShrink: 0,
  },
}));
